import { IconButton, styled } from '@material-ui/core';

export const CustomIconButton = styled(IconButton)({
  height: 18,
  width: 18,
  fontSize: 18,
  padding: 0,
  '& svg': {
    height: 20,
  },
});
